module.exports = __webpack_public_path__ + "img/ewm.207d36aa.png";